var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8249 3.50143V0.582581C21.5067 1.87197 25.7433 6.94453 25.7433 13.0089C25.7433 19.0733 21.5067 24.1459 15.8249 25.4353V22.5164C19.9198 21.2979 22.9094 17.5005 22.9094 13.0089C22.9094 8.51731 19.9198 4.71997 15.8249 3.50143ZM0.2388 8.75818V17.2597H5.90646L12.991 24.3443V1.67361L5.90646 8.75818H0.2388ZM19.3672 13.0089C19.3669 11.8217 19.0351 10.6582 18.4093 9.64934C17.7834 8.64049 16.8884 7.8264 15.8249 7.29876V18.7049C17.9219 17.6706 19.3672 15.5169 19.3672 13.0089Z",
    fill: "#F5F5F5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSicon);
export default __webpack_public_path__ + "static/media/sicon.0952a9955a55c7348c27ecaf10a07606.svg";
export { ForwardRef as ReactComponent };